<template>
  <article
    v-if="garage"
    class="garage-header"
  >
    <h1
      itemprop="name"
      class="garage-header__garage-name"
    >{{ garage.name }}</h1>

    <div class="garage-header__wrapper">
      <div
        class="garage-header__rating"
        :itemprop="!!totalComments ? 'aggregateRating' : undefined"
        :itemscope="!!totalComments ? true : undefined"
        :itemtype="!!totalComments ? 'http://schema.org/AggregateRating' : undefined"
      >
        <template v-if="!!totalComments">
          <meta
            itemprop="bestRating"
            content="6"
          >
          <meta
            itemprop="worstRating"
            content="0"
          >
          <meta
            itemprop="ratingValue"
            :content="`${garage.ratingTotal}`"
          >
          <meta
            itemprop="reviewCount"
            :content="`${totalComments}`"
          >
        </template>
        <div class="garage-header__rating-stars">
          <NuxtImg
            v-for="(item, index) in 6"
            width="18px"
            height="18px"
            class="garage-header__rating-star"
            alt="Ocena DobryMechanik.pl"
            :src="getStar(garage.ratingTotal || 0, index).toString()"
          />
        </div>
        <span class="garage-header__rating-total">{{ garage.ratingTotal }}</span>

        <span
          :href="`#${Tabs.Opinions}/`"
          class="garage-header__total-comments"
          @click="emits('go-to-tab', Tabs.Opinions)"
        >
          ({{ totalComments }} {{ getCommentsTranslatePL(totalComments) }})
        </span>
      </div>

      <div
        itemprop="geo"
        itemscope
        itemtype="http://schema.org/GeoCoordinates"
      >
        <meta
          itemprop="latitude"
          :content="garage.lat"
        />
        <meta
          itemprop="longitude"
          :content="garage.lng"
        />

        <p class="garage-header__address">
          {{ garage.address }},
          <a
            v-if="garage.quarter"
            :href="`/mechanicy/${route.params.city}/dzielnica/${garage.quarterSlug}/`"
          >
            {{ garage.quarter }}
          </a>
          <span v-if="garage.quarter">, </span>
          <a :href="`/mechanicy/${route.params.city}/`">
            {{ garage.city }}
          </a>
        </p>
      </div>
    </div>
  </article>
</template>

<script
  setup
  lang="ts"
>
import { getStar } from '@/helpers/get-star';
import type { GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead } from '~/api/docs/api';
import { Tabs } from '@/models/enums';
import type { GarageCommentStatistics } from '~/api/docs/app';
import { getCommentsTranslatePL } from '@/helpers/helpers';

interface IProps {
  garage?: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
  totalComments?: number;
  garageStats?: GarageCommentStatistics;
}

interface IEmits {
  (name: 'go-to-tab', value: Tabs): void;
}

// use
const route = useRoute();

// emits
const emits = defineEmits<IEmits>();

const props = defineProps<IProps>();
</script>

<style
  lang="scss"
  scoped
>
@import url('assets/styles/components/garage-header.scss');
</style>